import { TypeGuard } from './type';

export const isString = <T>(v: T): v is TypeGuard<string, T> =>
  typeof v === 'string';

export const isNotUndefined = (v: string | undefined): v is string =>
  typeof v === 'string';
